<template>
  <div>
    <a-modal
      v-model:visible="showModel"
      title="输入图片名称"
      @cancel="handleCancel"
      centered
      :width="300"
      :zIndex="10001"
    >
      <div>
        <a-input v-model:value="inputVal" placeholder="请输入" :maxlength="30" />
      </div>
      <template #footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
          :disabled="!inputVal"
        >
          保存健康档案
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script setup>
import { defineProps, computed, ref, defineEmits, watch } from 'vue'
import { useStore } from 'vuex'
import { uploadCheckFile, uploadSurveyFile } from '@/api/workPlace/checklist'
import { message } from 'ant-design-vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  },
  chatId: {
    type: [String, undefined],
    default: ''
  }
})
const emits = defineEmits(['cancelLibrary', 'update'])
const inputVal = ref('')
const loading = ref(false)
const showModel = computed(() => props.params.visible)
const store = useStore()
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const ucPatientId = curGroupInfo.value.patientInfo.ucUserId
const ucDoctorId = curGroupInfo.value.doctorInfo.ucUserId || null
const ucPatientName = curGroupInfo.value.patientInfo.username
const businessId = curGroupInfo.value.patientInfo.businessId || null
watch(
  () => showModel.value,
  val => {
    if (val) {
      inputVal.value = ''
    }
  }
)
const handleCancel = () => {
  inputVal.value = ''
  emits('cancelLibrary')
}
const handleOk = () => {
  const fileList = [
    {
      fileName: inputVal.value,
      filePath: props.params.filePath
    }
  ]
  loading.value = true
  let query = {}
  let api = ''
  if (props.params.type === 2) {
    query = {
      ucPatientId,
      ucDoctorId,
      ucPatientName,
      urlList: fileList,
      groupId: props.chatId,
      source: 1
    }
    api = uploadCheckFile
  } else {
    query = {
      pictureFileList: fileList,
      sendName: props.params.sendName,
      sendPersonId: getSendPersonId(props.params.sendPersonId),
      ucPatientId,
      ucDoctorId,
      patientId: businessId
    }
    api = uploadSurveyFile
  }
  api(query)
    .then(() => {
      message.success('上传成功')
    })
    .finally(() => {
      loading.value = false
      emits('cancelLibrary')
    })
}
const getSendPersonId = id => {
  if (!id) return null
  let personId = id
  const first = id.substr(0, 1)
  try {
    if (['p', 'a', 'z'].includes(first)) {
      personId = id.substr(1, id.length - 1)
    }
  } catch {
    personId = null
  }

  return personId
}
</script>
<style scoped lang="scss"></style>
